export const toFullName = (firstName?: string, lastName?: string) => [firstName, lastName].join(' ').trim();
